// extracted by mini-css-extract-plugin
export default {"container":"MicIndicator_container__9Jl7o","indicator":"MicIndicator_indicator__vqrHo","visuallyHidden":"MicIndicator_visuallyHidden__lHAse"};